module.exports = __webpack_public_path__ + "img/mb_hm_block03_02_tc.0fde3f39.jpg";